import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Avatar, Button, Center, Flex, Icon, Text } from '@chakra-ui/react';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationLink } from '../../components/NotificationLink';
import { NotificationTime } from '../../components/Time';
import { Eye } from '@kula-ai/icons-core';
import {
  Hackerrank,
  Hackerearth,
  CriteriaCorp,
  Hireflix,
} from '@/assets/icons/ats';

const ViewAssessment = ({ notification = {}, onClose = () => {} }) => {
  const [markAsRead] = useMarkAsReadMutation();
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  const { candidate, job, assessment, application_id } = data || {};
  const {
    id: candidateId,
    avatar_url: candidateAvatarUrl,
    name: candidateName,
  } = candidate || {};
  // todo check if id can be passed
  const { name: jobName, url: jobUrl } = job || {};
  const {
    id: assessmentId,
    name: assessmentName,
    platform: assessmentPlatform,
  } = assessment || {};

  const getPlatformConfig = (platform) => {
    switch (platform) {
      case 'hackerrank':
        return {
          bg: 'black',
          icon: Hackerrank,
        };
      case 'hackerearth':
        return {
          bg: 'black',
          icon: Hackerearth,
        };
      case 'criteriacorp':
        return {
          bg: '#09264E',
          icon: CriteriaCorp,
          iconProps: {
            width: '18px',
            height: '18px',
          },
        };
      case 'hireflix':
        return {
          bg: '#5862FF',
          icon: Hireflix,
          iconProps: {
            width: '18px',
            height: '18px',
          },
        };
      default:
        return {
          bg: 'ats-tertiary',
          icon: Eye,
        };
    }
  };

  const platformConfig = getPlatformConfig(assessmentPlatform);

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="46px" h="46px" borderRadius="full" bg={platformConfig.bg}>
        <Icon
          as={platformConfig.icon}
          color="ats-primary"
          {...platformConfig.iconProps}
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <Text>
          <Text as="span" size="sm-semi-bold">
            <NotificationLink
              to={`/candidates/${candidateId}`}
              label={`${candidateName}`}
              onClose={onClose}
              notification={notification}
            />
          </Text>
          <Text as="span" fontSize="sm">
            {' '}
            has submitted their assessment
          </Text>
        </Text>
        <Text size="sm-semi-bold">Details</Text>
        <Flex
          border="1px solid"
          borderColor="border-color"
          borderRadius="sm"
          p="14px"
          flexDir="column"
          gap="6px"
          mt="-6px"
        >
          <Text size="sm-semi-bold">Candidate</Text>
          <Flex mb="6px" gap="6px">
            <Avatar
              size="2xs"
              borderRadius="4px"
              className="avatar-xs"
              src={candidateAvatarUrl}
              name={candidateName}
            />
            <Text fontSize="sm">{candidateName}</Text>
          </Flex>
          <Text size="sm-semi-bold">Job</Text>
          <Text fontSize="sm" mb="6px">
            {jobName}
          </Text>
          <Text size="sm-semi-bold">Assessment</Text>
          <Text fontSize="sm" mb="6px">
            {assessmentName}
          </Text>
        </Flex>
        <NotificationTime notification={notification} />
        <Button
          w="fit-content"
          variant="ats-primary"
          borderRadius="8px"
          onClick={() => {
            markAsRead({ id: notification?.id });
            window.open(
              `${jobUrl}?tab=candidates&appId=${application_id}&viewAssessment=${assessmentId}`,
              '_self'
            );
            onClose();
          }}
          maxH="34px"
          data-test-id="view-assessment-button"
        >
          View assessment
        </Button>
      </Flex>
    </Flex>
  );
};

export const ViewAssessmentNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ViewAssessment notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
